/**
 * Shared badge component for portfolio type display (HL_PAPER / HYPERLIQUID).
 * Supports size variants: 'sm', 'md', 'lg'.
 */
export function PortfolioTypeBadge({ portfolioType, isTestnet, size = 'md' }) {
  const isPaper = portfolioType === 'HL_PAPER';
  const isHyperliquid = portfolioType === 'HYPERLIQUID';

  const sizeClasses = {
    sm: 'px-1 py-0.5 text-xs',
    md: 'px-2.5 py-1 text-sm',
    lg: 'px-3 py-1.5 text-base'
  };

  const iconSize = size === 'sm' ? 'w-2.5 h-2.5' : size === 'lg' ? 'w-5 h-5' : 'w-4 h-4';

  if (isPaper) {
    return (
      <span className={`inline-flex items-center gap-0.5 sm:gap-1.5 ${sizeClasses[size]} font-semibold rounded-full bg-amber-900/40 text-amber-300 border border-amber-700/50`}>
        <svg className={iconSize} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
        </svg>
        {size === 'sm' ? 'PPR' : 'PAPER'}
      </span>
    );
  }

  if (isHyperliquid) {
    return (
      <span className={`inline-flex items-center gap-0.5 sm:gap-1.5 ${sizeClasses[size]} font-semibold rounded-full ${
        isTestnet
          ? 'bg-purple-900/40 text-purple-300 border border-purple-700/50'
          : 'bg-emerald-900/40 text-emerald-300 border border-emerald-700/50'
      }`}>
        <svg className={iconSize} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
        {size === 'sm' ? (isTestnet ? 'TST' : 'HL') : (isTestnet ? 'HL TESTNET' : 'HL MAINNET')}
      </span>
    );
  }

  return null;
}
